import React, { useContext, useEffect, useState } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button, Grid, Typography } from "@mui/material";
import { Link, useLocation, useParams } from "react-router-dom";

import { Replacement } from "@safetyculture/s12-apis-connect-web/s12/accounts/admin/v1/white_label_pb";

import { UrlParamTypes } from "../types/org-display";
import { ListWhiteLabelReplacements } from "api/endpoints/custom-labels";
import { callOptionsHeaders } from "api/helpers";
import OrganisationCustomLabelsTable from "components/custom-labels/custom-labels-table";
import { SnackbarContext } from "context/snackbar-context";

type LocationState = {
  orgName: string;
};

const OrganisationCustomLabels = () => {
  const location = useLocation<LocationState>();
  const { regionCode, roleId } = useParams<UrlParamTypes>();
  const { orgName } = location.state || { orgName: "" };
  const [isLoading, setIsLoading] = useState(false);

  const [customLabels, setCustomLabels] = useState<Replacement[]>([]);

  const { showError } = useContext(SnackbarContext);

  const getReplacements = async (orgId: string) => {
    setIsLoading(true);
    return ListWhiteLabelReplacements(
      orgId,
      callOptionsHeaders(regionCode, roleId)
    )
      .then((res) => {
        setCustomLabels(res.replacements);
        setIsLoading(false);
      })
      .catch((error) => {
        showError(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getReplacements(roleId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} style={{ paddingBottom: "20px" }}>
          <Grid container alignContent="space-between" alignItems="center">
            <Grid item>
              <Link
                to={`/organisation/${regionCode}/${roleId}`}
                className="remove-link-style"
                style={{ position: "relative" }}
                data-testid="back-button"
              >
                <Button startIcon={<ArrowBackIcon />} color="primary">
                  Back
                </Button>
              </Link>
            </Grid>

            <Grid item xs={11}>
              <Typography
                variant="h5"
                color="textPrimary"
                gutterBottom
                data-testid="organisation-custom-labels-title"
              >
                {orgName && `${orgName} - `}
                Custom Labels
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <OrganisationCustomLabelsTable
        customLabels={customLabels}
        isLoading={isLoading}
        onUpdated={() => {
          setCustomLabels([]);
          getReplacements(roleId);
        }}
      />
    </>
  );
};
export default OrganisationCustomLabels;
